import React, { useContext, useState } from 'react';
import { CheckboxGroup, Checkbox } from 'chaoskit/src/components';

import {
  ReliabilityHelp,
  ReliabilityHelpTrigger,
  ReliabilityInput,
} from '../../pages/reliability-calculator';
import { ReliabilityCalculatorContext } from './Context';

export const getDefaultSLOBasedOnTier = step1 => {
  // eslint-disable-next-line default-case
  switch (step1) {
    case 'tier_1':
      return 99.999;
    case 'tier_2':
      return 99.99;
    case 'tier_3':
      return 99.9;
  }
};

const Step4 = () => {
  const {
    state: { step1, step4 },
    dispatch,
  } = useContext(ReliabilityCalculatorContext);
  const [helpOpen, toggleHelpOpen] = useState(false);
  const [disableInput, setDisableInput] = useState(false);

  return (
    <div className="reliabilityCalculator__cell">
      {helpOpen ? (
        <ReliabilityHelp
          title="Service-level objective"
          toggleHelpOpen={toggleHelpOpen}
        >
          <p>
            A service-level objective (SLO) is an agreed-upon target for a
            particular key performance indicator (KPI). SLOs establish the
            internal expectations of how a service should perform.
          </p>
          <p>
            An availability SLO refers to the percentage of time your service
            aims to be available. This is measured as a percentage. For example,
            "five nines") or 99.95% (sometimes "three nines five").
          </p>
          <p>
            <em>
              * Note that your SLO can differ from published service-level
              agreements (SLAs).
            </em>
          </p>
        </ReliabilityHelp>
      ) : (
        <div className="hero-titleWrapper u-contrast">
          <h1 className="hero-title">
            What is your availability{' '}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <ReliabilityHelpTrigger onClick={() => toggleHelpOpen(!helpOpen)}>
              service-level objective
            </ReliabilityHelpTrigger>{' '}
            (SLO)?
          </h1>
        </div>
      )}
      <ReliabilityInput
        name="slo-input"
        onChange={(name, value) =>
          dispatch({
            type: 'choice',
            payload: {
              step4: value,
            },
          })
        }
        disabled={disableInput}
        value={step4}
        explanationMessage="Measured as a percentage"
      />

      <CheckboxGroup className="reliabilityCalculator__checkbox u-contrast">
        <Checkbox
          name="slo-checkbox"
          onChange={(name, value, checked) => {
            if (checked) {
              dispatch({
                type: 'choice',
                payload: {
                  step4: getDefaultSLOBasedOnTier(step1),
                },
              });
            }

            setDisableInput(checked);
          }}
          label="We don't have an availability SLO"
          value="0"
        />
      </CheckboxGroup>
    </div>
  );
};

export default Step4;
